export default __webpack_public_path__ + "static/media/c-providore-raffles.74938da9.png";